import React from 'react';
import PaginatedIndexQuery from '../PaginatedIndexQueryContainer';
import CommunitySuggestionQuery from 'buyside/graphql/queries/CommunitySuggestions';

import OnboardingCommunitySuggestions from 'buyside/components/presentation/Onboarding/OnboardingForm/OnboardingCommunitySuggestions/onBoardingCommunitySuggestions';
import { FETCH_POLICIES } from 'buyside/components/container/PaginatedIndexQueryContainer.jsx';

import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

import styles from 'buyside/components/presentation/Onboarding/OnboardingForm/OnboardingCommunitySuggestions/onboardingCommunitySuggestionsStyles';

const OnboardingCommunitySuggestionsContainer = props => {
  const queryName = 'recommendedUsersToFollow';
  const pageSize = props.isAllocator ? 3 : 6;
  return (
    <PaginatedIndexQuery
      query={CommunitySuggestionQuery}
      queryName={queryName}
      secondaryField="currentUser"
      pageSize={pageSize}
      fetchPolicy={FETCH_POLICIES.NETWORK_ONLY}
    >
      {({ data, loading }) => {
        if (loading || !data) {
          return (
            <div>
              <h3 className={styles.fieldHeader}>Recommended Analysts</h3>
              <div className={styles.loadingArea}>
                <LoadingSpinner size="medium" />
              </div>
            </div>
          );
        }

        return data.recommendedUsersToFollow.edges.length ? (
          <OnboardingCommunitySuggestions data={data} pageSize={pageSize} {...props} />
        ) : (
          <div className={styles.noRecommendations}>
            You are currently following all top-ranked members for your watchlisted sectors; add new
            sectors or check back later for new recommendations.
          </div>
        );
      }}
    </PaginatedIndexQuery>
  );
};

export default OnboardingCommunitySuggestionsContainer;
